// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1OLJ3","colMin":"styles_colMin__1jwPm","colCheckbox":"styles_colCheckbox__3lCrm"};